/**
 * Author: Claude Code
 * Generation: Step 1 - Agent appearance selection with slime picker
 * Version: v3.2.45
 * Modified: 2025-11-04 (Fixed WebSocket import for Vite build)
 */
import { useEffect } from 'react';
import { useRoomStore } from '@store/RoomStore';
import { SlimePreview } from './SlimePreview';
import { normalizeColor } from '../../utils/colorMapping';
import WebSocketService from '../../services/websocket/WebSocketService';

export default function Step1Appearance() {
  const {
    currentSlimeIndex,
    availableSlimes,
    myAgentConfiguration,
    nextSlime,
    previousSlime,
    updateAgentName,
    selectedModelId,
    updateSelectedModel,
  } = useRoomStore();

  const currentSlime = availableSlimes[currentSlimeIndex];

  // Sync selected model to backend via WebSocket (100% WebSocket architecture)
  useEffect(() => {
    (async () => {
      try {
        const ack: any = await WebSocketService.emit('llm:select', { modelId: selectedModelId });
        if (!ack?.success) {
          console.warn('Failed to sync LLM model:', ack?.error || 'UNKNOWN');
        }
      } catch (e) {
        console.warn('WebSocket llm:select failed:', e);
      }
    })();
  }, [selectedModelId]);

  return (
    <div className="step-content active">
      <div className="step-header">
        <h3 className="step-title">Choose Your Slime</h3>
        <p className="step-subtitle">Select a character and give it a unique name</p>
      </div>

      <div className="slime-picker">
        <button className="slime-arrow" onClick={previousSlime}>←</button>
        {/* 方框中居中显示动画 */}
        <div className="slime-display">
          <div style={{ transform: 'translateX(-15px)' }}>
            <SlimePreview color={normalizeColor(currentSlime.emoji)} size={128} />
          </div>
        </div>
        <button className="slime-arrow" onClick={nextSlime}>→</button>
      </div>
      {/* 名称移到方框下方，避免影响箭头垂直居中 */}
      <div className="slime-name">{currentSlime.name}</div>

      <div className="form-group" style={{ marginTop: 'var(--space-8)' }}>
        <label className="form-label">Agent Name</label>
        <input
          type="text"
          className="form-input"
          placeholder="Enter name"
          value={myAgentConfiguration?.name || ''}
          onChange={(e) => updateAgentName(e.target.value)}
          maxLength={20}
        />
      </div>

      {/* LLM Model Selection */}
      <div className="form-group" style={{ marginTop: 'var(--space-4)' }}>
        <label className="form-label">LLM Model</label>
        <select
          className="select"
          value={selectedModelId}
          onChange={(e) => updateSelectedModel(e.target.value)}
        >
          <option value="doubao-seed-1-6-251015">Doubao Seed 1.6 (251015)</option>
          <option value="openai-gpt-5">OpenAI GPT-5</option>
          <option value="anthropic-claude-sonnet-4.5">Claude Sonnet 4.5</option>
          <option value="google-gemini-2.5-flash">Gemini 2.5 Flash</option>
          <option value="xai-grok-4">xAI Grok 4</option>
          <option value="qwen-qwen3-max">Qwen3 Max</option>
          <option value="deepseek-v3.1-terminus">DeepSeek V3.1 Terminus</option>
        </select>
        <div className="form-help">默认使用 Doubao（可根据需要切换至其它模型）</div>
      </div>
    </div>
  );
}
